import { css } from 'styled-components';

export interface IImageSource {
    src: string,
    webpSrc?: string,
}

/**
 * Позволяет браузеру выбрать наиболее подходящий формат фонового избражения с помощью CSS
 * @param {Object} [image] - Объект с путями картинок разного формата
 * @param {string} image.src - Путь до картинки с обычным форматом (jpeg/png)
 * @param {string} [image.webpSrc] - Путь до картинки формата webp
 * @returns {string} Стили CSS
 *
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/image/image-set MDN}
 */
export const progressiveBackground = (image?: IImageSource): ReturnType<typeof css> | string => {
    if (!image) {
        return '';
    }

    const { src, webpSrc } = image;

    if (!webpSrc) {
        return css`
            background-image: url(${src});
        `;
    }

    return css`
        background-image: url(${src});

        background-image: -webkit-image-set(
            url(${webpSrc}) 1x,
            url(${src}) 1x
        );

        background-image: image-set(
            url(${webpSrc}) type('image/webp') 1x,
            url(${src}) 1x
        );
    `;
};
